import React, { ChangeEvent } from "react";
import { FormSectionElements, FormSubSections, ProgramContainer } from "src/entities/formTemplateDataType";
import classNames from 'classnames';
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import { HintExpansionComponent } from "../odsCalloutBox/HintExpansionComponent";
import FormValidationUtils from "../../utilities/FormValidationUtils";
// import { gaEvent } from "../../utilities/GAUtils";
import axios from "axios";
import { apiUrl } from "../../config";
import { getRootComponent, isBxpForm } from "../../utilities/ElementUtils";
import DataUtils, { syncAllLoadBindName } from "../../utilities/DataUtils"; // Added import
import Utils from "../../utilities/Utils";
import { combineUrl } from "../../utilities/URLUtils";
import { SCRIPT_ENV } from "../../config/RuntimeConfig";
import SessionStorageService from "../../services/SessionStorageService";
import { TOKEN_TYPE } from "../../entities/Constants";
import CustomPopup from "./PopupComponent";


interface Props {
    field: FormSectionElements;
    editable: boolean;
    title;
    labelControlArray;
    requiredField;
    callbackElement;
    Visible: boolean;
    isEng: boolean;
    onBusyChange?: (isBusy: boolean) => void;
}

interface State {
    isExpanded: boolean;
    isVisible: boolean;
    showPopup: boolean;
    pendingSelection: { label: string; value: string | boolean } | null;
}
export class RadioButtonComponent extends React.Component<Props, State> {

    HtmlToReactParser = require('html-to-react').Parser;
    constructor(props: Props) {
        super(props);
        this.state = {
            isExpanded: false,
            isVisible: false,
            showPopup: false,
            pendingSelection: null,
        };
        let field = this.props.field;

        FormValidationUtils.runJavascript(field);

    }

    async componentDidMount(): Promise<void> {
        const field = this.props.field;
        this.setState({ ...this.state, isVisible: this.props.Visible });
        if (field.LovAPI) {
            const getUrl = field.LovAPI;
            let response;
            const root = getRootComponent(field);
            if (root.UseProxy == "Y") {
                let transferPayload = {
                    url: getUrl,
                    httpMethod: 'GET',
                    payload: ""
                }

                response = await axios.post(apiUrl() + "/tponTransfer", transferPayload);

            } else {
                let programContainer = getRootComponent(this.props.field);
                let token = SessionStorageService.getAuthToken(programContainer?.AuthRequired);                
                const headers = {
                    'Authorization': `Bearer ${token}`
                }

                const fullUrl = combineUrl(root.APIBasePath, getUrl);
                if (this.props.onBusyChange)
                    this.props.onBusyChange(true);
                response = await axios.get(fullUrl, { headers: headers });
                if (this.props.onBusyChange)
                    this.props.onBusyChange(false);
            }
            field.ListOfLOVValues = response.data;
            this.reconcilePreBoundValueWithLovOptions(field);
            this.props.callbackElement(root);
        }
    }

    reconcilePreBoundValueWithLovOptions = (field: FormSectionElements): void => {
        const currentValue = field.Value;
        if (currentValue === undefined || currentValue === null) return;

        const currentValueTrimmed = String(currentValue).trim();
        if (!currentValueTrimmed) return;

        const list = field.ListOfLOVValues ?? [];
        const codeMatch = list.find((opt) => String(opt?.code ?? '').trim() === currentValueTrimmed);
        if (codeMatch) {
            field.SelectionCode = codeMatch.code;
            return;
        }

        const normalizedCurrentValue = currentValueTrimmed.toLowerCase();
        const descMatch = list.find((opt) => {
            const description = String(opt?.description ?? opt?.name ?? '').trim().toLowerCase();
            const fraDescription = String(opt?.FRADescription ?? opt?.nameFrench ?? '').trim().toLowerCase();
            return description === normalizedCurrentValue || fraDescription === normalizedCurrentValue;
        });

        if (descMatch) {
            field.Value = descMatch.code;
            field.SelectionCode = descMatch.code;
        }
    }

    getGaTrackingId = () => {
        let section = this.props.field.parent;
        let trackingId = '';
        while (section && !section.GATrackingID) {
            section = section.parent;
        }

        return section?.GATrackingID;
    }

    isValueFilled = (v: unknown): boolean => {
        if (v === undefined || v === null) return false;
        return String(v).trim() !== '';
    };

    setSelectedRadio = (label: string, value: string | boolean) => {
        const field = this.props.field;
        if (field.ReadOnly) {
            return;
        }
        const previousValue = field.Value;
        const showPopupOnChange = !!field.ShowPopup &&
            this.isValueFilled(previousValue) &&
            this.isValueFilled(value) &&
            String(previousValue) !== String(value);
        if (showPopupOnChange) {
            this.setState({ showPopup: true, pendingSelection: { label, value } });
            return;
        }
        this.applyRadioSelection(label, value);
    };

    applyRadioSelection = (label: string, value: string | boolean) => {
        const field = this.props.field;
        field.Value = value;
        field.Label = label;
        FormValidationUtils.markFieldDirty(field);
        if (field?.syncAllBindingField && field?.parent?.parent?.parent) {
            syncAllLoadBindName(field.parent.parent.parent, field.LoadBindName, field.Value);
        }
        FormValidationUtils.validateRadioButton(field);
        FormValidationUtils.runJavascript(field);
        if (field.EventScript && Utils.isNotNullOrEmpty(field.EventScript)) {
            try {
                const customEventFunc = eval(`(${field.EventScript})`);
                if (typeof customEventFunc === 'function') {
                    customEventFunc(field, SCRIPT_ENV);
                }
            } catch (ex) {
                console.log(ex);
            }
        }
        this.props.callbackElement(getRootComponent(this.props.field));
    };

    handlePopupConfirm = () => {
        if (this.state.pendingSelection) {
            this.applyRadioSelection(this.state.pendingSelection.label, this.state.pendingSelection.value);
        }
        this.setState({ showPopup: false, pendingSelection: null });
    };

    handlePopupCancel = () => {
        this.setState({ showPopup: false, pendingSelection: null });
    };

    generateLabel = () => {
        const field = this.props.field;
        const root = getRootComponent(field);
        let labelControlArray = [];
        const title = this.props.isEng ? field.ENUTitle : field.FRATitle;
        const requireLabel = this.props.field.Optional == "N" ?
            root.UseAsterisks == "Y" ? <span style={{ color: 'red' }}>*</span> : this.props.isEng ? "(required)" : "(obligatoire)" :
            root.HideOptionalText == "Y" ? "" : root.UseAsterisks == "Y" ? '' : this.props.isEng ? "(optional)" : "(facultatif)"

        labelControlArray.push(
            <legend className="ontario-fieldset__legend" id={`label_${field.LoadBindName}`} style={field?.fieldSize ? { fontSize: field?.fieldSize } : undefined}>
                {title}
                <span className='ontario-label__flag'>
                    {title ? requireLabel : null}
                </span>{" "}
                {field.TooltipENU && (<i role='tooltip' title={field.TooltipENU} className="pi pi-info-circle"></i>)}
            </legend>
        )

        return labelControlArray;
    }

    render() {
        let field = this.props.field;
 
        FormValidationUtils.runJavascript(field);
        if (!field.Visible) return null;

        const htmlToReactParser = new this.HtmlToReactParser();

        const sectionReadOnly = field.parent?.parent?.SectionReadonly === true;
        field.ReadOnly = field.ReadOnly || sectionReadOnly;

        let editable = this.props.editable;

        let requiredField = this.props.requiredField;
        let controlArray = [];
        let title = this.props.title;
        const marginBottom = Utils.getSpacingValue(field.MarginBottom);
        const marginTop = Utils.getSpacingValue(field.MarginTop);
        const containerStyle: React.CSSProperties = {};
        if (marginBottom !== undefined) containerStyle.marginBottom = marginBottom;
        if (marginTop !== undefined) containerStyle.marginTop = marginTop;

        // Group continuation styling - collapse top spacing
        if (field.GroupContinuation) {
            containerStyle.marginTop = '0';
            containerStyle.paddingTop = '0';
        }

        if (editable) {
            var lovOptionList = [];
            field.ListOfLOVValues.forEach(lov => {
                let selectOptionName = (this.props.isEng ? lov.description?? lov.name : lov.FRADescription?? lov.nameFrench);
                if (selectOptionName === null || selectOptionName === '') {
                    selectOptionName = (this.props.isEng ? lov.code : lov.FRA);
                }
                let selectOptionValue = lov.code;
                let callOutBoxTitle = this.props.isEng ? lov.callOutBoxTitle : lov.callOutBoxTitleFRA;

                const callOutBoxBody = htmlToReactParser.parse(this.props.isEng ? lov.callOutBoxBody : lov.callOutBoxBodyFRA);
                let hintExpansionTitle = this.props.isEng ? lov.hintExpansionTitle : lov.hintExpansionTitleFRA;
                lovOptionList.push(
                    {
                        Sequence: lov.Sequence,
                        label: selectOptionName,
                        value: selectOptionValue,
                        hintExpansionTitle: hintExpansionTitle ? hintExpansionTitle : null,
                        hintExpansionContent: lov.hintExpansionContent ? (this.props.isEng ? lov.hintExpansionContent : lov.hintExpansionContentFRA) : null,
                        callOutBoxType: lov.callOutBoxType ? lov.callOutBoxType : null,
                        callOutBoxTitle: callOutBoxTitle ? callOutBoxTitle : null,
                        callOutBoxBody: callOutBoxBody ? callOutBoxBody : null,
                        parent: lov.parent,
                        Visible: lov.Visible,
                        Script: lov.Script,
                        convertToBoolean: lov.convertToBoolean ?? false,
                    }
                );
            });
            const hintHtml = this.props.isEng ? field.Hint : field.HintFR;
            let hint;
            if (field.Hint || field.HintFR) {
                hint = htmlToReactParser.parse(hintHtml);
            }
            const requiredLabel = this.props.field.Optional == "N" ? (this.props.isEng ? "(required)" : "(obligatoire)") : this.props.isEng ? "(optional)" : "(facultatif)"
            const hasTitle = this.props.isEng ? !!field.ENUTitle : !!field.FRATitle;

            controlArray.push(
                <>
                    <fieldset className={`ontario-fieldset${field.GroupContinuation ? ' group-continuation' : ''}`} style={containerStyle} id={`${field.LoadBindName}`} aria-describedby={field.Valid ? undefined : `${field.LoadBindName}-${field.Id}-error`}>
                        {hasTitle &&             
                        <legend className="ontario-fieldset__legend" id={`label_${field.LoadBindName}`} style={field?.fieldSize ? { fontSize: field?.fieldSize } : undefined}>
                            {title}
                            <span className='ontario-label__flag'>
                                {title ? requiredLabel : null}
                            </span>{" "}
                            {field.TooltipENU && (<i role='tooltip' title={field.TooltipENU} className="pi pi-info-circle"></i>)}
                        </legend>}                        
                        {hintHtml ? <p className="ontario-hint" id={`hint-text-${field.LoadBindName}`} tabIndex={field.Valid ? undefined : -1} style={field?.fieldHintSize ? { fontSize: field?.fieldHintSize } : undefined} dangerouslySetInnerHTML={{ __html: hintHtml }}></p> : null}
                        {!getRootComponent(field).ErrorBottom && (<LiveValidationErrMsg
                            field={this.props.field}
                            isEng={this.props.isEng}
                            key={"LiveValidationErrMsg_" + field.LoadBindName}
                            id={`${field.LoadBindName}-${field.Id}`}
                        />)}
                        {field.hintExpansionBelowElementLabel && (
                            <div className={`ontario-hint-expander__container ${this.state.isExpanded ? "ontario-expander--active" : ""}`}>
                                <button type="button"
                                    className={`ontario-hint-expander__button ${this.state.isExpanded ? "ontario-expander--active" : ""}`}
                                    id={`hint-expander-button-id-${field.LoadBindName}`}
                                    aria-controls={`hint-expander-content-${field.LoadBindName}`}
                                    aria-expanded={this.state.isExpanded}
                                    data-toggle="ontario-collapse"
                                    onClick={(e) => {
                                        this.setState({ isExpanded: !this.state.isExpanded });
                                    }}>
                                    <svg className="ontario-icon" aria-hidden={this.state.isExpanded ? "true" : "false"} focusable="false" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                                        {this.state.isExpanded ? <use href="#ontario-icon-chevron-up"></use> : <use href="#ontario-icon-chevron-down"></use>}
                                    </svg>
                                   
                                    {this.props.isEng ? field.hintExpansionTitle : field.hintExpansionTitleFRA}

                                </button>
                                {this.state.isExpanded && (
                                <div className={`ontario-hint-expander__content ${this.state.isExpanded ? "ontario-expander__content--opened" : ""}`} 
                                    id={`hint-expander-content-${field.LoadBindName}`} aria-labelledby={`hint-expander-button-id-${field.LoadBindName}`} 
                                    aria-hidden={this.state.isExpanded ? "false" : "true"} data-toggle="ontario-expander-content">
                                    {field.hintExpansionContent ? htmlToReactParser.parse(this.props.isEng ? field.hintExpansionContent : field.hintExpansionContentFRA) : null}
                                </div>)}
                            </div>
                        )}
                        <div className="ontario-radios">
                            <div style={field.Horizontal == 'Y' ? { display: 'flex', width: '100%' } : {}}>

                                {lovOptionList.map((val, index) => {
                                    if (val.Script) {
                                        const customJSFunc = eval(`(${val.Script})`);
                                        try {
                                            customJSFunc(val);
                                        } catch (ex) {
                                            console.log(ex);
                                        }
                                    }
                                    if (val.Visible == false) return null;

                                    let actualValue = val.value;
                                    if (val.convertToBoolean) {
                                        if (val.value === "true") actualValue = true;
                                        else if (val.value === "false") actualValue = false;
                                    }

                                    return (
                                        <div key={field.LoadBindName + "_" + val.value + "_" + index} className="ontario-radios__item" style={{ ...(field.Horizontal == 'Y' && { padding: "0 0.5rem 0 1.8rem" }), ...(getRootComponent(field).ErrorBottom && { marginBottom: '4px' }) }}>
                                            <input id={field.LoadBindName + '-' + index}
                                                onChange={() => this.setSelectedRadio(val.label, actualValue)}
                                                className={field.Valid ? "ontario-radios__input" : "ontario-radios__input ontario-radios__error"}
                                                type="radio"
                                                value={String(actualValue)}
                                                aria-invalid={(!field.Valid && field.Touched && index == 0) ? "true" : undefined}
                                                name={field.LoadBindName}
                                                readOnly={field.ReadOnly}
                                                aria-readonly={field.ReadOnly ? "true" : undefined}
                                                checked={this.props.field.Value == actualValue || String(this.props.field.Value) === String(actualValue)}
                                            />
                                            <label htmlFor={field.LoadBindName + '-' + index}
                                                className="ontario-label ontario-radios__label">
                                                {val.label}
                                            </label>
                                            {val.callOutBoxType != null && <HintExpansionComponent
                                                isEng={this.props.isEng} Visible={field.Visible}
                                                field={field}
                                                calloutType={val.callOutBoxType}
                                                bodyMsg={val.callOutBoxBody}
                                                title={val.callOutBoxTitle}
                                                hintExpansionTitle={val.hintExpansionTitle}
                                            />}
                                        </div>
                                    )
                                })}
                            </div>
                        </div>

                        {getRootComponent(field).ErrorBottom && (<LiveValidationErrMsg
                            field={this.props.field}
                            isEng={this.props.isEng}
                            key={"LiveValidationErrMsg_" + field.LoadBindName}
                            id={`${field.LoadBindName}-${field.Id}`}
                        />)}
                    </fieldset>
                </>
            );
        } else {
            // Review section values
            let matched = field.ListOfLOVValues.find(
                val => String(field.Value) === String(val.code)
            );

            let displayValue = matched ? (this.props.isEng ? matched.description : matched.FRADescription) : "";

            controlArray.push(
                <div className="pdf-two-column" style={containerStyle}>
                    <div>
                        {title}
                        <br></br>
                        {isBxpForm(this.props.field) ? htmlToReactParser.parse(this.props.isEng ? this.props.field.Hint : this.props.field.HintFR) : htmlToReactParser.parse(this.props.field.Hint)}
                    </div>
                    <div
                        className={classNames({
                            "invalid-field--highlighted": !!field.Valid == false
                        })}
                    >
                        {displayValue}
                    </div>
                </div>
            );
        }

        const popupTitle = this.props.isEng
            ? (this.props.field.PopupTitle || 'Confirm')
            : (this.props.field.PopupTitleFRA || 'Confirmer');
        const popupMessage = this.props.isEng
            ? (this.props.field.PopupMessage || '')
            : (this.props.field.PopupMessageFRA || '');
        const confirmLabel = this.props.isEng ? 'Confirm' : 'Confirmer';
        const cancelLabel = this.props.isEng ? 'Cancel' : 'Annuler';

        return (
            <>
                {controlArray}
                {this.state.showPopup && this.state.pendingSelection && (
                    <CustomPopup
                        key="radio-popup"
                        isVisible={this.state.showPopup}
                        title={popupTitle}
                        closable={true}
                        handleModalClose={this.handlePopupCancel}
                        customClass="custom-popup"
                    >
                        <div className="popup-content">
                            <p>{popupMessage ? (new this.HtmlToReactParser()).parse(popupMessage) : null}</p>
                            <div className="popup-buttons">
                                <button
                                    className="ontario-button ontario-button--primary"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        this.handlePopupConfirm();
                                    }}
                                >
                                    {confirmLabel}
                                </button>
                                <button
                                    className="ontario-button ontario-button--secondary"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        this.handlePopupCancel();
                                    }}
                                >
                                    {cancelLabel}
                                </button>
                            </div>
                        </div>
                    </CustomPopup>
                )}
            </>
        );
    }

}
